import Vue from 'vue';

/**
 * Async components are not used here since there's some slight delay when
 * loading them in other async components
 */

Vue.component('outlet-filter', require('./outlet-filter.vue'));



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/common/index.js